import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../utils/api';

interface User {
  id: number;
  last_name: string;
  avatar: string | null;
  first_name: string;
  email: string;
  phone: string;
  created_at: string;
  updated_at: string;
}

interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  type: 'agent' | 'technicien';
  login: (email: string, password: string , type : 'agent' | 'technicien') => Promise<void>;
  logout: () => Promise<void>;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<User | null>(null);
  const [type, setType] = useState<'agent' |'technicien'>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const initializeAuth = async () => {
      const token = await localStorage.getItem('token');
      const type = await localStorage.getItem('type');
      if (token) {
        try {
          //@ts-ignore
          await fetchUserData(token,type);
          setIsAuthenticated(true);
          //@ts-ignore
          setType(type);
        } catch (error) {
          console.error('Error initializing authentication:', error);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const fetchUserData = async (token: string, type : 'agent' | 'technicien') => {
    try {
      const response = await api.get<User>(`/${type=='technicien' ? 'technicien/' : '' }profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setUser(response.data);
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  };

  const login = async (email: string, password: string , type : 'agent' | 'technicien' ) => {
    try {
    
      const response = await api.post(`/${type=='technicien' ? 'technicien/' : '' }login`, { email, password });
      const { access_token	 } = response.data;


      await localStorage.setItem('token', access_token	);
      await localStorage.setItem('type', type	);
      
      await fetchUserData(access_token,type);
      setIsAuthenticated(true);
      setType(type)
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        await api.post(
          `/logout`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('type');
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading ,type}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};